<template>
  <router-view />
  <AccountBindPrompt />
</template>

<script>
import AccountBindPrompt from '@/components/AccountBindPrompt.vue'

export default {
  name: 'AppWrapper',
  components: { AccountBindPrompt }
}
</script>
